import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'

import Button from 'components/Button'

import DriversForm from 'components/DriversForm'

import { statusChanged } from 'components/RequestStatus/actions'
import { resetState } from 'scenes/ClientDetail/components/AddVehicleModal/actions'
import { driverListChanged } from './actions'

export class AddDriver extends BaseComponent {

  constructor() {
    super()

    this._bind('_onSuccess', '_submitForm', '_renderFooter')
  }

  _submitForm(submitForm) {
    return (evt) => {
      evt.preventDefault()
      this.setState({
        buttonProps: {
          disabled: true
        }
      })
      submitForm()
    }
  }

  _renderFooter(submitForm) {
    return (
      <div className="controls">
        <Button onClick={this._submitForm(submitForm)}>Agregar nuevo conductor</Button>
      </div>
    )
  }

  _onSuccess(res) {
    // only perform update if there are drivers or users to added/created!
    if (!!res) {
      this.props.updateRequestStatus('progress', 'Agregando conductores')
      this.props.updateRequestStatus(res.status, res.message)

      const newDrivers = this.props.drivers.concat(res.drivers)

      this.props.driverListChanged(newDrivers)
    }

    // hide modal and reset state in all cases
    this.context.hideModal()
    this.props.resetState()
  }

  render() {
    return (
      <div id="AddDriver" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Datos de cuenta</h1>
          <span className="material-icons close-button" onClick={() =>  this.context.toggleModal(false)}>clear</span>
        </div>
        <DriversForm
          onSuccess={this._onSuccess}
          clientId={this.props.userId}
          vehicleId={parseInt(this.props.vehicleId, 10)}
          renderFooter={this._renderFooter}
        />
      </div>
    )
  }
}

AddDriver.propTypes = {
  userId: PropTypes.string.isRequired,
  vehicleId: PropTypes.string.isRequired
}

AddDriver.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    drivers: state.driversVehicleDetail.get('drivers')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    resetState: () => dispatch(resetState()),
    driverListChanged: (drivers) => dispatch(driverListChanged(drivers))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddDriver)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/AddDriver.js